import React from 'react';

export const AddressIcon = ({ className }) => {
	return (
		<svg width="31" height="28" viewBox="0 0 31 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M15.5 0.880829C9.9875 0.880829 5.5 5.06916 5.5 10.2142C5.5 16.7125 14.2 25.7775 14.575 26.1625L15.5 27.1192L16.425 26.1625C16.8 25.7775 25.5 16.7125 25.5 10.2142C25.5 5.06916 21.0125 0.880829 15.5 0.880829ZM15.5 23.5958C12.775 20.5508 8 14.3442 8 10.2142C8 6.3525 11.3625 3.21416 15.5 3.21416C19.6375 3.21416 23 6.3525 23 10.2142C23 14.6825 17.6875 21.1342 15.5 23.5958ZM13.5875 12.7458L11.3875 10.6808L9.6125 12.3375L13.5875 16.0475L21.1 9.03583L19.3375 7.37916L13.5875 12.7458Z" fill="#5F5F5F" />
		</svg>
	);
};
